// This is the setup where we connect our sanity client with our react application 
// which allows us to use the Sanity Client to fetch real data from the Sanity Dashboard
import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = sanityClient({
    // Note : projectId and token has to be taken from Sanity Manage 
    // Actual projectId and token is in .env file 
    projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
    dataset: 'production',
    apiVersion: '2022-02-01',
    useCdn: true, 
    token: process.env.REACT_APP_SANITY_TOKEN,
});

// These are the code that we must always write when we are dealing with images in Sanity 
// Useful for our images 
const builder = imageUrlBuilder(client);
export const urlFor = (source) => builder.image(source);